import axios from "axios";

export async function getApiRequestHeader(isFormData = false) {
  try {
    const token = localStorage.getItem("accessToken");
    const resetToken = localStorage.getItem("resetToken");
    return {
      Accept: "application/json",
      "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      Authorization: `Bearer ${token || resetToken}`,
    };
  } catch (error) {}
}
const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 600000,
  withCredentials: false,
});

export const get = async (url, isFormData = false) => {
  const headers = await getApiRequestHeader(isFormData);
  return instance.get(url, { headers });
};

export const post = async (url, data = {}, isFormData = false) => {
  const headers = await getApiRequestHeader(isFormData);
  return instance.post(url, data, { headers });
};

export const put = async (url, data = {}, isFormData = false) => {
  const headers = await getApiRequestHeader(isFormData);
  return instance.put(url, data, { headers });
};

export const del = async (url, isFormData = false) => {
  const headers = await getApiRequestHeader(isFormData);
  return instance.delete(url, { headers });
};
